export enum UserRoles {
  ADMIN = 'ADMIN',
  COMPANY_MANAGER = 'COMPANY_MANAGER',
  MANAGER = 'MANAGER',
  TALENT = 'TALENT'
}
